// Modelo único del nivel de riesgo de un proyecto (campo `investmentRiskLevel`, numérico 0-6).
// Si la escala o los colores cambian, se actualiza solo aquí.
export interface InvestmentRiskInfo {
  level: number;
  letter: string;
  band: string;
  description: string;
  bgClass: string;
  textClass: string;
}

// `band` y `description` son claves i18n (OVERVIEW_PROJECT.*), se resuelven con el pipe `translate` en el template.
export const INVESTMENT_RISK_LEVELS: InvestmentRiskInfo[] = [
  {
    level: 0, letter: 'A+', band: 'OVERVIEW_PROJECT.RISK_BAND_A_PLUS',
    description: 'OVERVIEW_PROJECT.RISK_DESCRIPTION_A_PLUS',
    bgClass: 'bg-success', textClass: 'text-white'
  },
  {
    level: 1, letter: 'A', band: 'OVERVIEW_PROJECT.RISK_BAND_A',
    description: 'OVERVIEW_PROJECT.RISK_DESCRIPTION_A',
    bgClass: 'bg-active', textClass: 'text-eggplant-100'
  },
  {
    level: 2, letter: 'B', band: 'OVERVIEW_PROJECT.RISK_BAND_B',
    description: 'OVERVIEW_PROJECT.RISK_DESCRIPTION_B',
    bgClass: 'bg-active/50', textClass: 'text-eggplant-100'
  },
  {
    level: 3, letter: 'C', band: 'OVERVIEW_PROJECT.RISK_BAND_C',
    description: 'OVERVIEW_PROJECT.RISK_DESCRIPTION_C',
    bgClass: 'bg-cream-100', textClass: 'text-eggplant-100'
  },
  {
    level: 4, letter: 'D', band: 'OVERVIEW_PROJECT.RISK_BAND_D',
    description: 'OVERVIEW_PROJECT.RISK_DESCRIPTION_D',
    bgClass: 'bg-orange-70', textClass: 'text-white'
  },
  {
    level: 5, letter: 'E', band: 'OVERVIEW_PROJECT.RISK_BAND_E',
    description: 'OVERVIEW_PROJECT.RISK_DESCRIPTION_E',
    bgClass: 'bg-orange-100', textClass: 'text-white'
  },
  {
    level: 6, letter: 'F', band: 'OVERVIEW_PROJECT.RISK_BAND_F',
    description: 'OVERVIEW_PROJECT.RISK_DESCRIPTION_F',
    bgClass: 'bg-alert', textClass: 'text-white'
  },
];

export function getInvestmentRiskInfo(level: number | null | undefined): InvestmentRiskInfo | null {
  if (level === null || level === undefined) {
    return null;
  }
  return INVESTMENT_RISK_LEVELS.find(r => r.level === level) ?? null;
}
